import React from 'react';

import styles from './Bouton.module.scss';
import * as s from '../../../ressources/StyleGlobal/StyleGlobal';
import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import { VscRefresh } from 'react-icons/vsc';
import { IoIosClose } from 'react-icons/io';
import { FiMaximize, FiMinimize } from 'react-icons/fi';

const Bouton = (props) => {
  let classesBouton = [s.btn, s.btn_sm, props.ajoutClass, styles.btnATEsTER];

  if (props.rond) {
    classesBouton.push(styles.btnCircle);
  }

  //icône à afficher dans le bouton avant le text
  let icone = null;

  //type de bouton en fonction de props.types
  switch (props.type) {
    case type_btn.lupeSearchClose:
      classesBouton.push(styles.lupeSearchClose);

      break;
    case type_btn.lupeSearch:
      classesBouton.push(styles.lupeSearch);

      break;
    case type_btn.succeSimple:
      classesBouton.push(styles.succeSimple);

      break;
    case type_btn.succes:
      classesBouton.push(styles.btnSuccess);

      break;
    case type_btn.btnDisable:
      classesBouton.push(styles.btnSuccessDisable);

      break;
    case type_btn.danger:
      classesBouton.push(styles.btnDanger);

      break;
    case type_btn.Wait:
      classesBouton.push(styles.btnWait);

      break;
    case type_btn.actualiser:
      classesBouton.push(styles.btnSuccess);

      icone = <VscRefresh size={15} />; //icône de refresh qui s'affiche avant le text
      break;
    case type_btn.fermer:
      classesBouton.push(styles.btnFermer);

      icone = <IoIosClose size={30} />; //icône de refresh qui s'affiche avant le text

      break;
    case type_btn.Max:
      classesBouton.push(styles.btnMax);

      icone = <FiMaximize size={20} />; //icône de refresh qui s'affiche avant le text

      break;
    case type_btn.Min:
      classesBouton.push(styles.btnMin);

      icone = <FiMinimize size={20} />; //icône de refresh qui s'affiche avant le text

      break;
    case type_btn.popupferme:
      classesBouton.push(styles.popupferme);

      icone = <IoIosClose size={18} />; //icône de refresh qui s'affiche avant le text

      break;
    case type_btn.outil:
      classesBouton.push([styles.btnOutil, styles.btnCircle].join(' '));

      break;
    default:
      classesBouton.push(s.btn_primary);
  }

  let contentHoverText;
  if (props.hoverText !== undefined) {
    contentHoverText = (
      <span className={styles.classdutexte}>{props.hoverText}</span>
    );
  }

  return (
    <button
      type={props.type || 'button'}
      title={props.title}
      style={{ ...props.style }}
      className={classesBouton.join(' ')}
      onClick={props.cliquer}
      onDoubleClick={props.dobleClique}
      disabled={props.desactive ? 'disabled' : null}
    >
      {icone}
      {props.children} {contentHoverText}
    </button>
  );
};

export default Bouton;
